export const APP_NAME = 'vehicleDetails';
export const VEHICLE_DETAILS_ROUTE = '/vehicle-details';
